import { all } from 'redux-saga/effects';
import authSagas from '@tt/redux/auth/saga';
import authServiceSaga from '../services/auth/saga';

// Common Data
import commonServiceSaga from '../services/common/saga';

// User Level Details
import userDetailServiceSaga from '../services/userLevelDetails/saga';

// Dashboards Data
import globalDashboardServiceSaga from '../services/dashboards/globalDashboard/saga';
import factoryEfficiencyServiceSaga from '../services/dashboards/factoryEfficiency/saga';
import oeeGridDashboardServiceSaga from '../services/dashboards/oee/saga';
import oeeEquipmentDashboardServiceSaga from '../services/dashboards/oeeEquipment/saga';
import silosDashboardSaga from '../services/dashboards/silos/saga';
import silosAssignmentDashboardSaga from '../services/dashboards/silosAssignment/saga';
import silosEquipmentDashboardSaga from '../services/dashboards/silosEquipment/saga';
import liveFactorySaga from '../services/dashboards/live_factory/saga';
import visionDashboardSaga from '../services/dashboards/vision/saga';
import visionEquipmentDashboardSaga from '../services/dashboards/visionEquipment/saga';
import visionOLEDashboardSaga from '../services/dashboards/visionOLEDashboard/saga';
import contactTracingDashboardSaga from '../services/dashboards/visionContactTracing/saga';
import energyGridDashboardServiceSaga from '../services/dashboards/energy/saga';
import cSuitDashboardServiceSaga from '../services/dashboards/CSuitDashboard/saga';
import jobGridDashboardServiceSaga from '../services/dashboards/job/saga';
import maintenanceDashboardServiceSaga from '../services/dashboards/maintenance/saga';
import qualityAssuranceComplaintDashboardServiceSaga from '../services/dashboards/qualityAssurance/saga';
import auxiliaryGridDashboardServiceSaga from '../services/dashboards/auxiliary/saga';
import prismaticSaga from '../services/dashboards/prismatic/saga';

//Reports Data
import reportsSaga from '../services/reports/saga';

//Operations Data
import jobHistoryOperationServiceSaga from '../services/operations/job_history/saga';
import lineJobHistoryOperationServiceSaga from '../services/operations/line_job_history/saga';
import JobImportHistoryOperationServiceSaga from '../services/operations/job_import_history/saga';
import unassignedJobsOperationServiceSaga from '../services/operations/unassigned_jobs/saga';
import downtimeOperationServiceSaga from '../services/operations/downtime/saga';
import rejectionOperationServiceSaga from '../services/operations/rejection/saga';
import operatorSkillOperationServiceSaga from '../services/operations/operator_skills/saga';
import unidentifiedOperatorOperationServiceSaga from '../services/operations/unidentified_operator/saga';
import jobOperatorOperationServiceSaga from '../services/operations/job_operators/saga';
import productionOperationServiceSaga from '../services/operations/production/saga';
import toolAvgCycleTimeOperationSerivceSaga from '../services/operations/avg_cycletime/saga';
import eRPEquipmentMappingOperationServiceSaga from '../services/operations/erp_equipment_mapping/saga';
import erpJobImportLogsOperationServiceSaga from '../services/operations/erp_job_import_logs/saga';

// Maintenance Data
import maintenanceSaga from '../services/maintenance/saga';

// Quality Assurance Datas
import qualityAssuranceSaga from '../services/qualityAssurance/saga';

// Master Data
import factoryServiceSaga from '../services/master/factories/saga';
import operatorServiceSaga from '../services/master/operators/saga';
import shiftServiceSaga from '../services/master/shifts/saga';
import productServiceSaga from '../services/master/products/saga';
import departmentServiceSaga from '../services/master/departments/saga';
import rawMaterialServiceSaga from '../services/master/raw_materials/saga';
import equipmentServiceSaga from '../services/master/equipments/saga';
import auditLogsServiceSaga from '../services/master/audit_logs/saga';
import groupServiceSaga from '../services/master/groups/saga';
import lineServiceSaga from '../services/master/lines/saga';
import positionServiceSaga from '../services/master/positions/saga';
import jobTypeServiceSaga from '../services/master/job_types/saga';
import jobTitleServiceSaga from '../services/master/job_titles/saga';
import toolServiceSaga from '../services/master/tools/saga';
import crewServiceSaga from '../services/master/crews/saga';
import factoryAreasServiceSaga from '../services/master/factory_areas/saga';
import interestRegionServiceSaga from '../services/master/interest_region/saga';
import downtimeReasonServiceSaga from '../services/master/downtime_reasons/saga';
import downtimeCategoryServiceSaga from '../services/master/downtime_categories/saga';
import rejectionReasonServiceSaga from '../services/master/rejection_reasons/saga';
import lineJobReconciliation from '../services/dashboards/lineJobReconciliation/saga';
import rejectionTypeServiceSaga from '../services/master/rejection_types/saga';
import downtimeReasonHighlightsServiceSaga from '../services/master/downtime_reasons_highlights/saga';
import visionProjectSaga from '../services/master/visionProject/saga';
import productAttributeServiceSaga from '../services/master/productAttribute/saga';

export default function* rootSaga(getState) {
  yield all([
    authSagas(),
    authServiceSaga(),
    commonServiceSaga(),
    userDetailServiceSaga(),
    globalDashboardServiceSaga(),
    factoryEfficiencyServiceSaga(),
    liveFactorySaga(),
    oeeGridDashboardServiceSaga(),
    oeeEquipmentDashboardServiceSaga(),
    silosDashboardSaga(),
    silosAssignmentDashboardSaga(),
    silosEquipmentDashboardSaga(),
    energyGridDashboardServiceSaga(),
    cSuitDashboardServiceSaga(),
    jobGridDashboardServiceSaga(),
    maintenanceDashboardServiceSaga(),
    qualityAssuranceComplaintDashboardServiceSaga(),
    visionDashboardSaga(),
    visionEquipmentDashboardSaga(),
    visionOLEDashboardSaga(),
    contactTracingDashboardSaga(),
    auxiliaryGridDashboardServiceSaga(),

    reportsSaga(),

    jobHistoryOperationServiceSaga(),
    lineJobHistoryOperationServiceSaga(),
    JobImportHistoryOperationServiceSaga(),
    unassignedJobsOperationServiceSaga(),
    downtimeOperationServiceSaga(),
    rejectionOperationServiceSaga(),
    operatorSkillOperationServiceSaga(),
    unidentifiedOperatorOperationServiceSaga(),
    jobOperatorOperationServiceSaga(),
    productionOperationServiceSaga(),
    toolAvgCycleTimeOperationSerivceSaga(),
    eRPEquipmentMappingOperationServiceSaga(),
    erpJobImportLogsOperationServiceSaga(),

    maintenanceSaga(),
    qualityAssuranceSaga(),

    factoryServiceSaga(),
    rejectionReasonServiceSaga(),
    operatorServiceSaga(),
    shiftServiceSaga(),
    productServiceSaga(),
    departmentServiceSaga(),
    rawMaterialServiceSaga(),
    factoryAreasServiceSaga(),
    interestRegionServiceSaga(),
    equipmentServiceSaga(),
    auditLogsServiceSaga(),
    groupServiceSaga(),
    lineServiceSaga(),
    positionServiceSaga(),
    toolServiceSaga(),
    crewServiceSaga(),
    downtimeCategoryServiceSaga(),
    downtimeReasonServiceSaga(),
    downtimeReasonHighlightsServiceSaga(),
    jobTypeServiceSaga(),
    jobTitleServiceSaga(),
    lineJobReconciliation(),
    rejectionTypeServiceSaga(),
    visionProjectSaga(),
    prismaticSaga(),
    productAttributeServiceSaga(),
  ]);
}
